import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Tooltip,
    MenuItem,
    ListItemIcon,
    ButtonGroup,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, ColorLens, RemoveCircle, Save, Search } from '@mui/icons-material';

import { checkComponentPresence, getCategoryColor, makeid, myFormat, myTimestampToDate, propComparator, propComparatorDate } from '../utils/ui_utils';

import { add_category_template, get_category_template_list } from '../FirebaseUtils/dbSettings';
import DeleteconfirmationSection from '../components/DeleteConfirmationSection';
import { get_Cow_list, update_cows_param } from '../FirebaseUtils/dbCow';
import { useEvent } from '../context/eventContext';
import { getCowLight } from '../definitions/cow';
import { CategoryLabel } from '../definitions/category';



const compareCows = (propNameB) =>
    (a, b) =>
    (b.category?.category_number - a.category?.category_number) 
|| 
        (myTimestampToDate(a[propNameB]) - myTimestampToDate(b[propNameB]))


export const CatalogInitNumberDialog = ({ cow_list, reloadFn }) => {

    const { selEvent } = useEvent()
    const childRefDelete = useRef()
    const [open, setOpen] = useState(false);
    const [new_list, setNewList] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [initMode, setInitMode] = useState('category')


    const handleOpen = () => {
        if (selEvent.id) {
            const total_count = cow_list.length
            let _c_list = cow_list.sort(compareCows('birthdate')).map((c, k) => ({ cow_id: c.id, value: (total_count - k) }))
            console.log(cow_list)
            setNewList(_c_list)
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };


    useEffect(() => {
        const total_count = cow_list.length
        if (initMode === 'category') {
            let _c_list = cow_list.sort(compareCows('birthdate')).map((c, k) => ({ cow_id: c.id, value: (total_count - k) }))
            setNewList(_c_list)
        } else {
            let _c_list = cow_list.sort(propComparatorDate('birthdate')).map((c, k) => ({ cow_id: c.id, value: (total_count - k) }))
            setNewList(_c_list)
        }

    }, [initMode])



    const initCatalogNumber = async () => {
        const event_id = selEvent.id
        setLoading(true)
        if (event_id) {
            const res = await update_cows_param(event_id, 'catalog_id', new_list)
            console.log("CATALOG RES", res)
            if (res) {
                const cdata = await get_Cow_list(event_id)
                const cow_dict = Object.assign({}, ...cdata.map((x) => ({ [x.id]: x })))
                reloadFn()
            }
        }
        setLoading(false)
        setOpen(false)

    }

    return (
        <div>
            <MenuItem disabled={cow_list.length === 0} onClick={handleOpen} disableRipple>
                <ListItemIcon>
                    <ColorLens />
                </ListItemIcon>
                Inizializza numeri catalogo
            </MenuItem>
            {/*             <Button variant="outlined" color="warning" size="small" onClick={handleOpen} startIcon={<ColorLens />}>inizializza numeri catalogo</Button> */}
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="xl">
                <DeleteconfirmationSection ref={childRefDelete} />
                <DialogTitle>
                    <b>
                        Inizializza numeri catalogo
                    </b>
                </DialogTitle>
                <DialogContent>
                    Verranno inizializzati tutti i numeri di catalogo di tutti i soggetti inseriti in questo evento, partendo dal n° 1 <br />
                    <ButtonGroup>
                        <Button variant={initMode === 'category' ? 'contained' : 'outlined'} onClick={() => setInitMode('category')}>per categoria (e data di nascita)</Button>
                        <Button variant={initMode === 'birthdate' ? 'contained' : 'outlined'} onClick={() => setInitMode('birthdate')}>per data di nascita</Button>
                    </ButtonGroup>
                    {new_list.length > 0 && <>
                        {new_list.map((c,k) => <OneCow cow={cow_list[cow_list.length-1 -k]} catalog_id={new_list[cow_list.length-1 -k].value} key={k}/>)}
                    </>}
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    <Button color="secondary" variant="contained" disabled={selEvent.lock_catalog} loading={isLoading} onClick={() => initCatalogNumber()}>
                        Esegui inizializzazione
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}


const OneCow = ({ cow, catalog_id}) => {
    return (
        <Grid container>
            <Grid size={0.5}>
                {catalog_id}
            </Grid>
            <Grid size={1.5} flexDirection={"row"} container>
                {cow.cow_type === 'red' ?
                    <Tooltip placement="right" title="red holstein">
                        <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                    :
                    <Tooltip placement="right" title="holstein">
                        <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                }
                {cow.serial}
            </Grid>
            <Grid size={"grow"}>
                {cow.name}
            </Grid>
            <Grid size={1}>
                {cow.birthdate && <>
                    {myFormat(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                </>}
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={"grow"}>
                <CategoryLabel category={cow.category} />
                {cow.category?.category_name}
            </Grid>
        </Grid>
    )

}